import { AuthContextProps } from "../components/auth-context";
import { getData, postData, putData } from "./core";
import Contact from "../types/contact";

export default class ContactApi {
  static unauthorizedUri = "n/accounts/contact";
  static authorizedUri = "a/accounts/contact";
  context?: AuthContextProps;
  constructor(context?: AuthContextProps) {
    this.context = context;
  }
  get(page: number, rows: number) {
    return getData({
      uri: ContactApi.authorizedUri,
      params: `?page=${page}&rows=${rows}`,
      context: this.context,
    });
  }
  post(data: Contact) {
    return postData({
      uri: ContactApi.authorizedUri,
      data,
    });
  }

   put(data: Contact) {
    return postData({
      uri: ContactApi.authorizedUri,
      data,
    });
  }
}
